import { api } from "./api";
import { URL } from '../utils/constant'



export const loginUser = (data) => {
    return api.post(URL.login, JSON.stringify({
        data: data
    }), {
        method: "POST",
        headers: {
            "content-type": "application/json"
        }
    })
}
export const logout = () => {
    api.defaults.headers.common['Authorization'] = sessionStorage.getItem('auth');
    return api.post(URL.logout, {
        method: "POST",
        headers: {
            "content-type": "application/json"
        }
    })
}

export const refreshToken = (token) => {
    api.defaults.headers.common['Authorization'] = token;
    return api.post(URL.refresh, {
        method: "POST"
    })
}


export const changeRole = (role) => {
    return api.post(URL.changeRole, JSON.stringify({
        role: role
    }), {
        method: "POST",
        headers: {
            "content-type": "application/json"
        }
    })
}

